// this file is automatically generated by app-version-info.ts script at build time
/* tslint:disable */export const appVersionInfo = {
  version: '4.146.0',
  revision: 'interface-4.146',
  dateTime: 1744820278103,
  branch: 'HEAD'};